export default function (pluginsHandler) {
    return {
        name: 'theme-default',
        style: 'default.css',
    }
}
